import { render, staticRenderFns } from "./ReservationStatusBadge.vue?vue&type=template&id=757515d4"
import script from "./ReservationStatusBadge.vue?vue&type=script&lang=js"
export * from "./ReservationStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports